import React from 'react';

export default class Uploading extends React.Component {
   constructor(props) {
      super(props);
      this.el = null;
      this._rmTimer = null;
      this.onFadeOutDone = this.onFadeOutDone.bind(this);
   }

   componentDidMount() {
      if (this.props.isShow) {
         this.ensureRoot();
         this.renderMask();
      }
   }

   componentDidUpdate(prevProps) {
      const cur = !!this.props.isShow;
      const prev = !!prevProps.isShow;

      if (cur && !prev) {
         this.ensureRoot();
         this.renderMask();
      } else if (!cur && prev) {
         this.fadeOutAndRemove();
      } else if (cur) {
         this.renderMask();
      }
   }

   componentWillUnmount() {
      if (this._rmTimer) clearTimeout(this._rmTimer);
      this.removeRoot();
   }

   ensureRoot() {
      if (this.el && document.body.contains(this.el)) return;
      var exist = document.getElementById('global-mask-root');
      if (exist) {
         this.el = exist;
         return;
      }
      this.el = document.createElement('div');
      this.el.setAttribute('id', 'global-mask-root');
      document.body.appendChild(this.el);
   }

   removeRoot() {
      if (this.el && this.el.parentNode) {
         this.el.parentNode.removeChild(this.el);
         this.el = null;
      }
   }

   onFadeOutDone() {
      if (this._rmTimer) {
         clearTimeout(this._rmTimer);
         this._rmTimer = null;
      }
      this.removeRoot();
   }

   fadeOutAndRemove() {
      if (!this.el) return;
      const box = this.el.querySelector('#global-loading-mask');
      if (!box) return this.removeRoot();
      // 觸發淡出
      box.style.opacity = '0';
      // 轉場完成後移除
      box.addEventListener('transitionend', this.onFadeOutDone, { once: true });
      // 後援計時器，避免某些瀏覽器不觸發事件
      this._rmTimer = setTimeout(this.onFadeOutDone, 400);
   }

   renderMask() {
      if (!this.el) return;
      const noteStr = String(this.props.noteStr || '');
      this.el.innerHTML = `
         <div id="global-loading-mask">
            <img role='img' src='/imgs/loading.gif' alt='' />
            ${noteStr ? `<div class='text-center' style='position:fixed; font-weight:bold; margin:-10px 0 0 0; background:#fff; font-size:18px; width:120px; box-shadow:rgba(0,0,0,0.25) 0 14px 28px,rgba(0,0,0,0.22) 0 10px 10px; border-radius:4px;'>${noteStr}</div>` : ''}
         </div>
      `;
   }

   render() {
      return null;
   }
}


// WEBPACK FOOTER //
// ./src/commonComponents/DataLoading.jsx